export const transformToNavigationPart = (res) => ({
  ...res,
  parent_id: res.parent_id ? parseInt(res.parent_id, 10) : null,
  sort: res.sort ? parseInt(res.sort, 10) : null,
});
